import { Injectable } from '@angular/core';
import { filter, map, Observable, Subject } from 'rxjs';

interface EventBusEvent<T> {
  type: string;
  payload: T;
}

@Injectable({
  providedIn: 'root',
})
export class EventBusService {
  private readonly eventBus = new Subject<EventBusEvent<unknown>>();

  emit<T>(event: EventBusEvent<T>): void {
    this.eventBus.next(event);
  }

  on$<T>(type: string): Observable<T> {
    return this.eventBus.asObservable().pipe(
      filter((event): event is EventBusEvent<T> => event.type === type),
      map(event => event.payload)
    );
  }
}
